import React from 'react';
import CoachListFunctional from './components/coach-list-functional';

const CoachList = () => {
	return <CoachListFunctional />;
};

export default CoachList;
